import { v4 as uuidv4 } from 'uuid';

import { type DerivedEventFilterLegacy, DerivedEventTypeLegacy } from '@verantos-dev/types-cohorts';

export const getNewCohortBuilderEvent = (
  type: DerivedEventTypeLegacy,
  isSelection?: boolean
): DerivedEventFilterLegacy => {
  return {
    id: uuidv4(),
    eventName: { id: uuidv4(), value: '' },
    eventDateAttribute: { id: uuidv4(), value: '' },
    isSelected:
      type === DerivedEventTypeLegacy.SEQUENCE
        ? { id: uuidv4(), value: isSelection ? 'true' : 'false' }
        : undefined, // event selection for sequence events
    position: type === DerivedEventTypeLegacy.INSTANCE ? { id: uuidv4(), value: '' } : undefined, // position for instance events
  };
};
